import React from "react";

export const CrossIcon = () => {
    return (
        <svg width="18" height="18" viewBox="0 0 18 18" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                fillRule="evenodd"
                clipRule="evenodd"
                d="M17.6415 1.70711C18.0321 1.31658 18.0321 0.683417 17.6415 0.292893C17.251 -0.0976311 16.6178 -0.0976311 16.2273 0.292893L8.96721 7.553L1.70711 0.292893C1.31658 -0.0976311 0.683417 -0.0976311 0.292893 0.292893C-0.0976311 0.683417 -0.0976311 1.31658 0.292893 1.70711L7.553 8.96721L0.292893 16.2273C-0.0976311 16.6178 -0.0976311 17.251 0.292893 17.6415C0.683417 18.0321 1.31658 18.0321 1.70711 17.6415L8.96721 10.3814L16.2273 17.6415C16.6178 18.0321 17.251 18.0321 17.6415 17.6415C18.0321 17.251 18.0321 16.6178 17.6415 16.2273L10.3814 8.96721L17.6415 1.70711Z"
                fill="#585858"
            />
        </svg>
    );
};
